import React from "react";
import { Container } from "reactstrap";
import _List from "./../_List";

import { connect } from "react-redux";
import { get, remove } from "./../../store/ducks/climates";

import { ContentTable, Header } from "./../../components";

class ClimatesList extends _List {
  render() {
    const { data } = this.props;

    return (
      <>
        <Header />
        <Container className="mt--7 bg-default" fluid>
          <ContentTable
            columns={[
              {
                title: "Título",
                slug: "title"
              },
              {
                title: "Temperaturas",
                slug: "temperatures"
              }
            ]}
            data={data}
            hasInsert={true}
            middleware={row => {
              row.temperatures = (
                <>
                  {row.min_temperature}°C até {row.max_temperature}°C
                </>
              );

              return row;
            }}
            onDelete={this.props.remove}
          />
        </Container>
      </>
    );
  }
}

const mapStateToProps = ({ common, climates }) => ({
  currentRoute: common.currentRoute,
  data: climates.data,
  loading: climates.loading,
  loadingBar: common.loadingBar
});

const mapDispatchToProps = {
  get,
  remove
};

export default connect(mapStateToProps, mapDispatchToProps)(ClimatesList);
